import { render, staticRenderFns } from "./RpmFuelSpeed.vue?vue&type=template&id=56bd2488&scoped=true"
import script from "./RpmFuelSpeed.vue?vue&type=script&lang=js"
export * from "./RpmFuelSpeed.vue?vue&type=script&lang=js"
import style0 from "./RpmFuelSpeed.vue?vue&type=style&index=0&id=56bd2488&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.38_cache-loader@4.1.0_webpack@4.44.2__css-load_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd2488",
  null
  
)

export default component.exports